<template>
  <b-card no-body tag="article" class="product-card text-center">
    <router-link :to="productRoute">
      <b-card-img
        :src="(product.picture && product.picture.picture)? product.picture.picture: fallback"
        :alt="product.description"
        top
        class="w-75"
        @error="imageLoadError"
      ></b-card-img>
    </router-link>
    <b-card-body class="d-flex flex-column">
      <div class="mt-auto">
        <div class="product-name mb-2">
          <router-link :to="productRoute">{{ product.description }}</router-link>
        </div>
        <div v-if="price" class="product-price">
          {{ $formatMoney(price, currency) }}
        </div>
        <b-button
          variant="cart"
          class="mt-3 mb-2 px-2 py-0"
          :disabled="!price"
          @click="buyProduct()"
        >
          <vue-element-loading :active="to_cart_loading" />
          {{ $t('product_card_compact.add') }}
        </b-button>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import ProductCard from "@/components/ProductCard";

export default {
  name: "product-card-compact",
  extends: ProductCard,
  fallbackI18n: {
    messages: {
      und: {
        product_card_compact: {
          add: "Add",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.product-card {
  background-color: $main-bg-color;
  max-width: $product-card-max-width;
}

.product-price {
  color: $corp-color1;
  font-size: $font-size-base * 1.1;
  font-weight: bold;
}

.product-name {
  font-size: $font-size-base * 1.1;
  font-weight: bold;
}

.product-name a {
  color: $text-main-color;
  text-decoration: none;
}

.btn-cart {
  min-width: 0;
}
</style>
